import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useLanguage } from './LanguageContext';

// EN | ES switch. Lives in the top bar (and on the sign-in screens) so it is one tap from anywhere.
// `onDark` renders it for the navy app bar.
export default function LanguageToggle({ onDark = false, sx }) {
    const { lang, setLang, t } = useLanguage();
    const color = onDark ? '#fff' : undefined;
    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            value={lang}
            onChange={(e, next) => next && setLang(next)}
            aria-label={t('nav.language')}
            sx={{
                ...(onDark && { '& .MuiToggleButton-root': { color, borderColor: 'rgba(255,255,255,0.5)' } }),
                '& .MuiToggleButton-root.Mui-selected': onDark
                    ? { color: '#0C447C', bgcolor: '#fff', '&:hover': { bgcolor: '#e8eef5' } }
                    : {},
                '& .MuiToggleButton-root': { px: 1.25, py: 0.5, fontWeight: 700, minWidth: 40 },
                ...sx,
            }}
        >
            <ToggleButton value="en">EN</ToggleButton>
            <ToggleButton value="es">ES</ToggleButton>
        </ToggleButtonGroup>
    );
}
